import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-24 md:py-32 flex flex-col items-center justify-center text-center">
        <p className="font-label text-6xl md:text-8xl font-black text-background-300 select-none">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-500 max-w-md">
          你访问的页面不存在或已被移除，不如回首页挑一部片子。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors inline-flex items-center whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="h-10 px-5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-secondary-400 transition-colors inline-flex items-center whitespace-nowrap cursor-pointer"
          >
            浏览电影
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}